import { RoadRage } from '../../RoadRage';
import { GameData } from '../../server/data/BaseModel';
import { FsLeftBox } from "../../background/FsLeftBox";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SoundManager } from '../../config/sound/SoundManager';
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { SplashController, SplashIndex } from '../../independent/splashScreen/SplashController';
import { RoadRageSpriteSymbol } from '../../reel/symbol/RoadRageSpriteSymbol';
import { PosterManager } from '../../independent/poster/PosterManager';

export class BonusIntroPresentation extends Presentation {

    protected gameData:GameData;
    protected onClickSound:string;
    protected loopSoundForSetup:string;
    protected nextModePreferedSize:number = 3;

    protected willAddFs:boolean = false;
    
    checkForActivation(data: GameData): boolean {
        return data.nextModeSetup;
    }

    setGamedData(data: GameData): void {
        this.gameData = data;
        this.nextModePreferedSize = data.Reel.amountOfScattersLanded;
        this.onClickSound = SoundConfig.SPLASH_INTRO_BTN[this.nextModePreferedSize-3];

        this.loopSoundForSetup = LoopSoundVal(this.nextModePreferedSize!-3);

        function LoopSoundVal(val: number): string {
            return SoundConfig.FS_MUSIC_SETUP_LOOP[val];
        }
    }

    preStart(): void {
        SplashController.instance.setData(SplashIndex.INTRO,this.gameData);
        FsLeftBox.instance.setAmount(this.gameData.raw.freespinsLeft - (this.gameData.fsInfo.addedNumberOfFreespinsThisSpin ? this.gameData.fsInfo.addedNumberOfFreespinsThisSpin : 0));
        RoadRageEngineManager.preferedLayoutSize = this.nextModePreferedSize;

        this.willAddFs = !!this.gameData.Reel.stickWildPos.length;
    }
    
    createPresentation(): void {

        if(RoadRage.counter.timeRemaining){
            this.timeline.to(this,{duration:RoadRage.counter.timeRemaining});
            return;
        }

        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        SlotGame.keypadPlugin.hide(1);
        // RoadRage.overlayAnim.onIdle(false);
        RoadRage.backgroundElements.speedUpCloud();

        if(this.willAddFs){
            FsLeftBox.instance.setAmount(0);

            this.timeline.to(this,{duration:0.5});

            this.timeline.add(FsLeftBox.instance.enable(true));

            let totalAmmAdded = 0;
            this.gameData.Reel.stickWildPos.forEach((s,i) => {
                const sym:RoadRageSpriteSymbol = RoadRageEngineManager.getReel(s.reel).getSymbol(s.row)!;
                const ammount:number = sym.symName === "WC4" ? 2 : 1;

                this.timeline.add(() => { 
                    SoundManager.playSoundEffect(SoundConfig.PLUS_ONE_FREESPIN);
                    FsLeftBox.instance.setAmount(totalAmmAdded+ammount);
                    totalAmmAdded += ammount;
                });
                
                this.timeline.add(RoadRage.overlayAnim.playPlusOneFS(sym, ammount));
            })

            this.willAddFs = false;

            return;
        }

        PosterManager.instance.hideSign();

        this.timeline.add(SplashController.instance.play(SplashIndex.INTRO,true,() => {
            SoundManager.playSoundEffect(this.onClickSound);
            SoundManager.playSoundEffect(this.loopSoundForSetup,Number.MAX_SAFE_INTEGER);
        }));
        
        
        this.PresentationState.setInactive();
    }

    public done(): void {

        if(this.nextModePreferedSize === 3){
            RoadRage.backgroundElements.playNormalSwitch(false,1);
            if(!this.gameData.isRestoreState)
                RoadRage.reelManager.miniCovering(true);
        }
        
        FsLeftBox.instance.enable(true);
    }
}